export default "__VITE_ASSET__6vwKKstb__"